<template>
    <div style="overflow: hidden; pointer-events: none">
        <div class="text-xs-center">
            <v-dialog :persistent="persistent" v-model="showing" width="500">
                <v-card>
                    <v-card-title class="lighten-2" primary-title>{{title}}</v-card-title>
                    <v-divider :inset="inset"></v-divider>
                    <v-card-text class="pa-6 py-2 body-1" style="min-height: 100px;" align-center v-html="message"></v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="onCancelClicked" :ripple="false" class="cancle_button" text v-if="shouldShowNegative">
                            {{buttonNegativeText}}
                        </v-btn>
                        <v-btn @click="onConfirmClicked" :ripple="false" class="workcancle_button" text color="#0c98fe" v-if="shouldShowPositive">
                            {{buttonPositiveText}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>

<script>
    import {ACTION_SHOW_DIALOG} from "./constants";

    export default {
        name: "DialogOverlay",
        data() {
            return {
                showing: false,
                title: null,
                message: null,
                buttonNegativeText: null,
                buttonNegativeCallback: null,
                buttonPositiveText: null,
                buttonPositiveCallback: null,
                inset: false,
                items: [
                    'vertical'
                ],
                ripple:false
            }
        },

        computed: {
            /**
             *
             * @returns {Boolean}
             */
            shouldShowNegative() {
                return !(this.$isNOU(this.buttonNegativeText) || this.$isNOU(this.buttonNegativeCallback));
            },
            /**
             *
             * @returns {Boolean}
             */
            shouldShowPositive() {
                return !(this.$isNOU(this.buttonPositiveText) || this.$isNOU(this.buttonPositiveCallback));
            },
            /**
             *
             * @returns {Boolean}
             */
            persistent() {
                return this.shouldShowNegative || this.shouldShowPositive;
            }
        },

        methods: {
            spreadOptions: function (options) {
                this.type = options.type;
                this.title = options.title;
                this.message = options.message;
                this.buttonNegativeText = options.buttonNegativeText;
                this.buttonNegativeCallback = options.buttonNegativeCallback;
                this.buttonPositiveText = options.buttonPositiveText;
                this.buttonPositiveCallback = options.buttonPositiveCallback;
            },
            showDialog(options) {
                if (this.showing) return;
                if (this.$isNOU(options)) return;
                this.spreadOptions(options);
                this.showing = true;
            },
            onCancelClicked() {
                this.buttonNegativeCallback();
                this.showing = false;
            },
            onConfirmClicked() {
                this.buttonPositiveCallback();
                this.showing = false;
            },
        },

        created() {
            this.$mps_dialog_event_bus.$on(ACTION_SHOW_DIALOG, this.showDialog);
        },

        beforeDestroy() {
            this.$mps_dialog_event_bus.$off(ACTION_SHOW_DIALOG, this.showDialog);
        }
    }
</script>

<style scoped>
    .workcancle_button {
        width: 90px;
    }
    .v-btn:before {
        color: transparent;
    }
</style>
